import React from 'react'
import { Badge, Button, Tooltip } from '@material-ui/core'
import {
    Launch,
    MonetizationOn,
    Add,
    Tune,
    Edit,
    Link,
    Star,
} from '@material-ui/icons'
import { Container } from '../../../components'
import { Schedule } from '../../../models'
import { CREATE_WORKORDERS, SEE_VENDOR_FINANCES } from '../../../models'
import { hasPermission } from '../../../models/Users/services'
import { useUser } from '../../../hooks'
import { useSchedulerHeaderStyles } from './styles'

interface Props {
    schedule?: Schedule
    editMode: boolean
    filterOpen: boolean
    clickSchedule: () => void
    clickBudget: () => void
    clickAssign: () => void
    clickFilter: () => void
    clickBulkEdit: () => void
    clickChangeOrder: () => void
    pendingChangeOrderCount?: number
    showRateVendors?: boolean
    onClickRateVendors?: () => void
}

export const SchedulerHeaderBigButtons = (props: Props) => {
    const classes = useSchedulerHeaderStyles()
    const { workspaceUser } = useUser()
    const { schedule } = props

    return (
        <Container className={classes.bigActionButtonsRow}>
            <Tooltip title="Schedule this Project">
                <Button
                    variant="outlined"
                    className={classes.bigActionButtonOutlined}
                    onClick={props.clickSchedule}
                    startIcon={<Launch />}
                >
                    Schedule
                </Button>
            </Tooltip>
            <Tooltip title="Budget Details">
                <span>
                    <Button
                        variant="outlined"
                        className={classes.bigActionButtonOutlined}
                        onClick={props.clickBudget}
                        disabled={
                            props.editMode ||
                            !hasPermission(workspaceUser, SEE_VENDOR_FINANCES)
                        }
                        startIcon={<MonetizationOn />}
                    >
                        Budget
                    </Button>
                </span>
            </Tooltip>
            <Tooltip title="Assign">
                <span>
                    <Button
                        variant="outlined"
                        className={classes.bigActionButtonOutlined}
                        onClick={props.clickAssign}
                        disabled={
                            !hasPermission(workspaceUser, CREATE_WORKORDERS) ||
                            !schedule?.active
                        }
                        startIcon={<Add />}
                    >
                        Assign
                    </Button>
                </span>
            </Tooltip>
            <Tooltip title="Filter">
                <Button
                    variant={props.filterOpen ? 'contained' : 'outlined'}
                    className={
                        props.filterOpen
                            ? classes.bigActionButton
                            : classes.bigActionButtonOutlined
                    }
                    onClick={props.clickFilter}
                    startIcon={<Tune />}
                >
                    Filter
                </Button>
            </Tooltip>
            <Tooltip title="Bulk Edit">
                <Button
                    variant={props.editMode ? 'contained' : 'outlined'}
                    className={
                        props.editMode
                            ? classes.bigActionButton
                            : classes.bigActionButtonOutlined
                    }
                    onClick={props.clickBulkEdit}
                    startIcon={<Edit />}
                >
                    Bulk Edit
                </Button>
            </Tooltip>
            <Tooltip title="Change Orders">
                <Badge
                    badgeContent={props.pendingChangeOrderCount ?? 0}
                    color="secondary"
                >
                    <Button
                        variant="outlined"
                        className={classes.bigActionButtonOutlined}
                        onClick={props.clickChangeOrder}
                        startIcon={<Link />}
                    >
                        Change Order
                    </Button>
                </Badge>
            </Tooltip>
            {props.showRateVendors && (
                <Tooltip title="Rate vendors for this project">
                    <Button
                        variant="outlined"
                        className={classes.bigActionButtonOutlined}
                        onClick={props.onClickRateVendors}
                        startIcon={<Star />}
                    >
                        Rate vendors
                    </Button>
                </Tooltip>
            )}
        </Container>
    )
}
